import { PortFormErrors, PortPayload, PORT_OPERATORS } from "./types";

export function validatePort(portItem: Partial<PortPayload>): PortFormErrors {
  const errors: PortFormErrors = {};

  const operator = portItem.operator?.toString().trim();
  if (!operator) errors.operator = "Operador é obrigatório";
  else if (!PORT_OPERATORS.includes(operator))
    errors.operator = `Operador deve ser ${PORT_OPERATORS.join(", ")}`;

  const port = portItem.port?.toString().trim();
  if (!port) errors.port = "Porta é obrigatória";
  else if (!/^\d+$/.test(port)) errors.port = "Informe apenas números";
  else if (Number(port) > 65535) errors.port = "Porta deve ser até 65535";

  return errors;
}
